import { type TFunction } from "i18next"

export const searchfieldTemplate = (t: TFunction) => `
<div class="addsearch-searchfield-container">
  <form class="addsearch-searchfield" autocomplete="off" action="?" role="search" data-gtm="search">
    <div class="search-field-wrapper flex justify-between rounded bg-white border-1">
      <input type="text" class="w-full px-4 py-3 border-none focus:outline-none helpcenter-search" placeholder="${t(
        "help_center.search_placeholder"
      )}" aria-label="Search field"/>
      <span class="flex items-center">
        <span class="close-icon px-3 m-auto cursor-pointer">
          <span class="hidden">
            <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.707 18.707a1 1 0 01-1.414-1.414L10.586 12 5.293 6.707a1 1 0 011.414-1.414L12 10.586l5.293-5.293a1 1 0 111.414 1.414L13.414 12l5.293 5.293a1 1 0 01-1.414 1.414L12 13.414z" fill="currentColor"/></svg>
          </span>
        </span>
        <span class="h-6 m-auto border-l-1 border-white-20"></span>
        <span class="left-icon px-3 m-auto cursor-pointer flex items-center">
          <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M11 3a8 8 0 104.906 14.32l3.387 3.387a1 1 0 001.414-1.414l-3.387-3.387A8 8 0 0011 3zm-6 8a6 6 0 1112 0 6 6 0 01-12 0z" fill="currentColor" fill-rule="evenodd"/></svg>
        </span>
      </span>
    </div>
  </form>
</div>
 `

export const searchresultsTemplate = (widget?: boolean) => {
  const href = widget ? "" : 'href="{{url}}"'
  return `
  <div class="addsearch-searchresults results z-10">
    {{#if resultcount}}
      {{> numberOfResultsTemplate}}
    {{/if}}
    {{#each hits}}
      {{#if custom_fields.answer}}
        <div class="hit{{#equals type "PROMOTED"}} promoted{{/equals}} question">
          <div class="header" onclick="this.parentElement?.querySelector('.answer')?.classList.toggle('hidden'); this.querySelector('.chewron-up')?.classList.toggle('hidden'); this.querySelector('.chewron-down')?.classList.toggle('hidden');" data-analytics-click="{{id}}" data-title="{{title}}">
            <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="M12 7a3 3 0 011 5.83V13a1 1 0 11-2 0v-1c0-.552.448-1 1-1a1 1 0 10-1-1 1 1 0 11-2 0 3 3 0 013-3zM13 16a1 1 0 11-2 0 1 1 0 012 0z"/><path clip-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z" fill-rule="evenodd"/></g></svg>
            <p class="mb-0">{{title}}</p>
            <span class="chewron-up hidden">
              <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M8.293 13.707a1 1 0 001.414 0L12 11.414l2.293 2.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 000 1.414z" fill="currentColor" fill-rule="evenodd"/></svg>
            </span>
            <span class="chewron-down">
              <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M8.293 10.293a1 1 0 011.414 0L12 12.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" fill="currentColor" fill-rule="evenodd"/></svg>
            </span>
          </div>
          <div class="paragraph-xs mb-0 answer hidden">{{{custom_fields.answer}}}</div>
        </div>
      {{else}}
        <div class="hit{{#equals type "PROMOTED"}} promoted{{/equals}} article">
          <a ${href} data-analytics-click="{{id}}" data-title="{{title}}" data-help-article-id="{{custom_fields.help_article_id}}">
            <div class="header">
              <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="m8 7c-.55228 0-1 .44772-1 1s.44772 1 1 1h8c.5523 0 1-.44772 1-1s-.4477-1-1-1z"/><path d="m7 12c0-.5523.44772-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-8c-.55228 0-1-.4477-1-1z"/><path d="m8 15c-.55228 0-1 .4477-1 1s.44772 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z"/><path clip-rule="evenodd" d="m3 4c0-.55228.44772-1 1-1h16c.5523 0 1 .44772 1 1v16c0 .5523-.4477 1-1 1h-16c-.55228 0-1-.4477-1-1zm2 15v-14h14v14z" fill-rule="evenodd"/></g></svg>
              <p class="mb-0">{{title}}</p>
            </div>
            <p class="paragraph-xs mb-0 highlight text-ink-85">{{{highlight}}}</p>
          </a>
        </div>
      {{/if}}
    {{/each}}
  </div>
`
}

export const numberOfResultsTemplate = (t: TFunction) => `
  <div class="number-of-results">
    <p class="paragraph-sm mb-0">
      {{total_hits}}{{#equals total_hits 10000}}+{{/equals}} ${t("help_center.results_for")} "{{keyword}}"
    </p>
  </div>
`

export const noResultsTemplate = (t: TFunction) => `
<div class="addsearch-searchresults addsearch-searchresults-no-results">
  <span>
    <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="M12 17a1 1 0 110-2 1 1 0 010 2zM12 14a1 1 0 01-1-1V8a1 1 0 112 0v5a1 1 0 01-1 1z"/><path clip-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2a8 8 0 100-16 8 8 0 000 16z" fill-rule="evenodd"/></g></svg>
  </span>
  <h4 class="center">${t("help_center.no_results")}</h4>
  <p class="paragraph-xs center mb-0">
    ${t("help_center.broader_term")}<a href='${t("route.contact")}'>${t("help_center.contact_us")}</a>.
  </p>
</div>
`
